import { searchClient as client } from '@algolia/client-search';

import config from '@/config';

export const searchClient = client(
  config.ALGOLIA_APP_ID,
  config.ALGOLIA_API_KEY,
);

export const SearchIndices = {
  EPISODES: 'prod_lumiq_episodes',
  LEARNING_PATHS: 'prod_lumiq_learning_paths',
  EPISODES_QUERY_SUGGESTIONS: 'prod_lumiq_episodes_query_suggestions',
};
